import React from 'react';
import './Button.scss';
import { Link } from 'react-router-dom';

interface IProps {
  style?: string;
  type?: 'submit';
  size?: 'standard' | 'large';
  color?: 'transparent' | 'red' | 'purple' | 'black';
  extraRadius?: boolean;
  boxShadow?: boolean;
  redirectUrl?: string;
  isDisabled?: boolean;
  localPath?: string;
  onClick?: () => void;
}

const Button: React.SFC<IProps> = ({
  style = '',
  size = 'standard',
  color = 'red',
  extraRadius = false,
  boxShadow = false,
  redirectUrl,
  localPath,
  isDisabled,
  onClick,
  type,
  children,
}) => {

  const buttonStyle = `button ${ color } ${ size } ${ boxShadow ? 'shadow' : '' }  ${ isDisabled ? 'disabled' : '' } ${ extraRadius ? 'extra-radius' : '' }`;

  if (redirectUrl) {
    return (
      <a className={ style } href={ redirectUrl } target='_blank'>
        <button type={ type } onClick={ onClick } className={ `${ buttonStyle }` }>
          { children }
        </button>
      </a>
    );
  }

  if (localPath) {
    return (
      <Link className={ style } to={ localPath }>
        <button type={ type } onClick={ onClick } className={ `${ buttonStyle }` }>
          { children }
        </button>
      </Link>
    );
  }

  return (
    <button type={ type } onClick={ onClick } className={ `${ buttonStyle } ${ style }` }>
      { children }
    </button>
  );
};

export default Button;


// WEBPACK FOOTER //
// ./src/components/Shared/Button/Button.tsx